import React from 'react'

import ErrorBoundary from './components/ErrorBoundary'
import FlashToasts from './components/FlashToasts'

import MainPage from './pages'

const App = () => (
  <ErrorBoundary>
    <MainPage />
    <FlashToasts bottom={'2rem'} right={'2rem'} />
  </ErrorBoundary>
)

export default App
